// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","443":"about"}[chunkId] + "." + {"177":"1db30b21","443":"e19b4324"}[chunkId] + ".css";
};